/* eslint-disable indent */
import NewLogo from "../../assets/png/NewLogoicon.png";
import NewSquare from "../../assets/svg/NewSquare.svg";
import NewList from "../../assets/svg/NewList.svg";
import NewTasks from "../../assets/svg/NewTasks.svg";
import NewSettings from "../../assets/svg/NewSettings.svg";
import NewProjectSquare from "../../assets/svg/NewProjectSquare.svg";
import NewProjectTasks from "../../assets/svg/NewProjectTasks.svg";
import NewProjectMembers from "../../assets/svg/NewProjectMembers.svg";
import NewPlus from "../../assets/svg/NewPlus.svg";
import NewLogout from "../../assets/svg/NewLogout.svg";
import NewUpArrow from "../../assets/svg/NewUpArrow.svg";
import DoubleLeftArrow from "../../assets/svg/DoubleLeftArrow.svg";
import RiskManagement from "../../assets/svg/RiskManagement.svg";
import Gantt from "../../assets/svg/ganttNew.svg";
import Workload from "../../assets/svg/Workload.svg";
import { useEffect, useRef, useState } from "react";
import { useUser } from "@/hooks/useUser";
import { useNavigate, useParams } from "react-router-dom";
import CreateProjectForm from "../project/CreateProjectForm";
import { Project } from "@/api/query/useProjectQuery";
import { useAuth } from "@/hooks/useAuth";
import { UserRoleEnumValue } from "@backend/src/schemas/enums";
import { Button } from "../ui/button";
import { useTranslation } from "react-i18next";
import { usePlanValidation } from "@/hooks/usePlan";
import useSettingsQuery from "@/api/query/useVersionQuery";
import { toast } from "react-toastify";
import { cn } from "@/lib/utils";
import { Briefcase, Package, Layers } from "lucide-react";
import { HierarchyItem } from "@/helperFuntions/projectherarch";
import useProjectWithoutCalulationQuery from "@/api/query/useProjectWithoutCalulationQuery";
export type SideBarNewProps = {
  isShow: boolean;
  setOpen: (d: boolean) => void;
};

export const SidebarNew = (props: SideBarNewProps) => {
  const { validatePlan } = usePlanValidation();
  const { t } = useTranslation();
  const { id, projectId } = useParams();
  const navigate = useNavigate();
  const { user } = useUser();
  const projectQuery = useProjectWithoutCalulationQuery(true);
  const { logout } = useAuth();
  const [showProjectMenu, setShowProjectMenu] = useState<string>("");
  const [isPopUpOpen, setIsPopUpOpen] = useState<boolean>(false);
  const [isPm, setIsPm] = useState<number[] | null>(null);
  const [isSubType, setIsSubType] = useState<string | null>(null);
  const settingQuery = useSettingsQuery();
  const BaseTabs = [
    {
      Id: 1,
      Image: NewSquare,
      Name: t(`portfolio_dashboard`),
      Path: `/`,
      plan: true, // selectedPlan.features.includes("portfolioDashboard"),
    },
    {
      Id: 2,
      Image: NewList,
      Name: t(`project_list`),
      Path: `/projects`,
      plan: true,
    },
    {
      Id: 3,
      Image: NewTasks,
      Name: t(`mytask`),
      Path: `/mytasks`,
      plan: true,
    },
    {
      Id: 4,
      Image: Gantt,
      Name: t(`Workload Planning`),
      Path: `/capacity-planning`,
      plan: true,
    },
    {
      Id: 5,
      Image: NewSettings,
      Name: t(`organisation_settings`),
      Path: `/organisation/${user?.userOrganisation[0]?.organisationId}`,
      plan: true,
    },
  ];
  const ProjectTabs = [
    {
      Id: 1,
      Image: NewProjectSquare,
      Name: t(`project_dashboard`),
      Path: `/projectDashboard/`,
      plan: true, //selectedPlan.features.includes("projectDashboard"),
      subType: "projectDashboard",
    },
    {
      Id: 2,
      Image: NewProjectTasks,
      Name: t("project_tasks"),
      Path: `/tasks/`,
      plan: true,
      subType: "tasks",
    },
    {
      Id: 3,
      Image: Workload,
      Name: t("project_workload"),
      Path: `/workload/`,
      plan: true,
      subType: "workload",
    },
    {
      Id: 4,
      Image: NewProjectMembers,
      Name: t("project_members"),
      Path: `/members/`,
      plan: true,
      subType: "members",
    },
    {
      Id: 5,
      Image: RiskManagement,
      Name: t("Risk Management"),
      Path: `/risk/`,
      plan: true,
      subType: "risk",
    },
    {
      Id: 6,
      Image: NewSettings,
      Name: t("project_settings"),
      Path: `/project-details/`,
      plan: true,
      subType: "project-details",
    },
  ];
  const handleOpenPopUp = () => {
    if (validatePlan("project").valid) {
      setIsPopUpOpen(!isPopUpOpen);
    }
  };

  const [isMobailView, setIsMobailView] = useState(false);
  useEffect(() => {
    // setIsMobailView(window.outerWidth < 768);
    setIsMobailView(false);
  }, []);

  useEffect(() => {
    const subType = location.split("/")[1];
    if (subType) {
      setIsSubType(subType);
    }
  }, []);

  useEffect(() => {
    if (id || projectId) {
      setShowProjectMenu((id || projectId) ?? "");
      props.setOpen(true);
    }

    if (!id && !projectId) {
      setShowProjectMenu("");
    }
    convertToHierarchyData(
      projectQuery.data?.data.data.sort(
        (a, b) =>
          new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
      ) ?? []
    );
  }, [projectQuery.data?.data.data, id, projectId]);
  useEffect(() => {
    const projects = projectQuery.data?.data.data ?? [];

    if (!user) return;

    const isAdmin =
      user.userOrganisation[0]?.role === UserRoleEnumValue.ADMINISTRATOR;

    if (isAdmin) {
      setIsPm([1, 2, 3, 4, 5]);
      return;
    }

    const totalProjects = projects.length;

    const userAssignments = projects.map((project) =>
      project.assignedUsers.find((au) => au.user.userId === user.userId)
    );

    const assignedCount = userAssignments.length;

    const userRoles = [
      ...new Set(userAssignments.map((au) => au?.projectRole)),
    ];

    const isPMInAll =
      userRoles.length === 1 &&
      userRoles[0] === UserRoleEnumValue.PROJECT_MANAGER &&
      assignedCount === totalProjects;

    const isPMInSome = userAssignments.some(
      (au) => au?.projectRole === UserRoleEnumValue.PROJECT_MANAGER
    );

    const isAssignedToAllSameRole =
      assignedCount === totalProjects && userRoles.length === 1;

    const hasSameNonPMRoleInAll =
      isAssignedToAllSameRole &&
      [UserRoleEnumValue.TEAM_MEMBER, UserRoleEnumValue.COLLABORATOR].includes(
        userRoles[0] as any
      );

    let access: number[] = [];

    if (isPMInAll || isPMInSome) {
      access = [1, 2, 3, 4];
    } else if (hasSameNonPMRoleInAll) {
      access = [1, 2, 3]; // All assigned with same role (TEAM_MEMBER or COLLABORATOR)
    } else {
      access = [1, 2, 3]; // Mixed roles or partial assignment
    }

    setIsPm(access);

    convertToHierarchyData(
      projects.sort(
        (a, b) =>
          new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
      )
    );
  }, [projectQuery.data?.data.data, user]);

  const newProjectRef = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    if (
      showProjectMenu !== null &&
      newProjectRef.current &&
      (id ?? projectId)
    ) {
      const activeElement =
        newProjectRef?.current[showProjectMenu as unknown as number];
      if (activeElement) {
        activeElement.scrollIntoView({ behavior: "auto", block: "end" });
      }
    }
  }, [id, projectId, showProjectMenu]);

  const containerRef = useRef<HTMLDivElement | null>(null);
  const location = window.location.pathname;
  const [version, setVersion] = useState("");
  const [currentVersion, setCurrentVersion] = useState("");

  useEffect(() => {
    setVersion(settingQuery.data?.data.data?.appVersion ?? "");
    setCurrentVersion(localStorage.getItem("VERSION") ?? "");
  }, [settingQuery.data?.data.data]);

  useEffect(() => {
    if (version && settingQuery.isFetched) {
      if (currentVersion !== version) {
        if (!toast.isActive("toast14")) {
          toast.success(
            <div className="lg:flex gap-1 items-center">
              <p className=" text-wrap">
                {t(
                  "A new version of ProjectChef has been released. Please reload the page"
                )}
                <br />
              </p>
              <div className="flex justify-end items-center">
                <button
                  onClick={() => window.location.reload()}
                  className="border-b border-b-white outline-none mt-1 text-xs"
                >
                  {t("reload")}
                </button>
              </div>
            </div>,
            { autoClose: false, toastId: "toast14" }
          );
        }

        // Only update version in localStorage after showing toast
        localStorage.setItem("VERSION", version);
      }
    }
  }, [version, settingQuery.isFetched]);

  type expandedProject = Project & { type: string };
  type ProjectHierarchy = {
    portfolioId?: string;
    portfolioName?: string;
    projects: expandedProject[];
    type: string;
    programs?: program[];
    project?: Project;
  };
  type program = {
    programId: string;
    programName?: string;
    type: string;
    projects: expandedProject[];
  };
  const [convertToHierarchy, setConvertToHierarchy] = useState<any>();
  const convertToHierarchyData = (projectsList: Project[]) => {
    const hierarchyMap = new Map<string, ProjectHierarchy>();
    const orphanProgramsMap = new Map<string, program>();
    const standaloneProjects: Project[] = [];
    // First Pass - Build Structure
    projectsList.forEach((p: Project) => {
      const hasPortfolio = !!p.portfolio;
      const hasProgram = !!p.program;

      if (!hasPortfolio && !hasProgram) {
        standaloneProjects.push(p);
        return;
      }

      if (!hasPortfolio && hasProgram) {
        if (!orphanProgramsMap.has(p.program!.programId)) {
          orphanProgramsMap.set(p.program!.programId, {
            programId: p.program!.programId,
            programName: p.program!.programName || "",
            type: "program",
            projects: [],
          });
        }
        orphanProgramsMap
          .get(p.program!.programId)
          ?.projects.push({ ...p, type: "project" });
        return;
      }

      if (!hierarchyMap.has(p.portfolio!.portfolioId)) {
        hierarchyMap.set(p.portfolio!.portfolioId, {
          portfolioId: p.portfolio!.portfolioId,
          portfolioName: p.portfolio!.portfolioName || "",
          type: "portfolio",
          projects: [],
          programs: [],
        });
      }

      const portfolioEntry = hierarchyMap.get(p.portfolio!.portfolioId)!;

      if (hasProgram) {
        let programEntry = portfolioEntry.programs?.find(
          (pr) => pr.programId === p.program?.programId
        );

        if (!programEntry) {
          programEntry = {
            programId: p.program!.programId,
            programName: p.program!.programName || "",
            type: "program",
            projects: [],
          };
          portfolioEntry.programs?.push(programEntry);
        }
        programEntry.projects.push({ ...p, type: "project" });
      } else {
        portfolioEntry.projects.push({ ...p, type: "project" });
      }
    });

    // Second Pass - Rebuild Final Hierarchy in Sorted Order
    const sortedHierarchy = projectsList
      .map((p) => {
        if (p.portfolio) return hierarchyMap.get(p.portfolio.portfolioId);
        if (p.program) return orphanProgramsMap.get(p.program.programId);
        return p;
      })
      .filter(Boolean);

    const uniq = [...new Set(sortedHierarchy)];
    setConvertToHierarchy(uniq);
  };

  return (
    <div
      id="Sidebar"
      className={`${isMobailView ? "absolute z-0  w-full h-full " : ""} ${
        props.isShow && "z-30"
      } max-w-[20%]`}
      ref={containerRef}
    >
      <div className="relative w-full  h-full">
        {!isMobailView && (
          <div className="absolute -right-4 top-20 z-40 transition-all duration-150">
            <Button
              variant={"primary_outline"}
              className="w-fit h-fit p-2 shadow-md"
              onClick={() => props.setOpen(!props.isShow)}
            >
              <img
                src={DoubleLeftArrow}
                alt=""
                className={`h-4 w-4 ${!props.isShow && "rotate-180"}`}
              />
            </Button>
          </div>
        )}
        <div
          className={`bg-secondary-950 h-full flex  text-white flex-col items-center justify-between w-full transition-all duration-150 ${
            !props.isShow && "!w-5"
          }  ${!props.isShow && isMobailView && "!hidden"}`}
        >
          <div className=" flex flex-col md:gap-6 xl:gap-8 justify-center w-full h-full">
            <div className="flex gap-1 md:px-5 md:pt-5 items-center">
              <div className="md:w-7 md:h-7 xl:w-10 xl:h-10">
                <img
                  className="w-full h-full align-middle"
                  src={NewLogo}
                  alt="No Logo Found"
                />
              </div>
              <div className="md:text-xl xl:text-2xl font-bold">
                ProjectChef
              </div>
              {isMobailView && (
                <div
                  className="md:text-xl xl:text-2xl font-bold ml-auto"
                  onClick={() => props.setOpen(!props.isShow)}
                >
                  x
                </div>
              )}
            </div>
            <div
              className="flex flex-col md:gap-6 xl:gap-6 w-full px-2 grow md:px-5 pb-5 h-full overflow-auto"
              style={{ scrollbarWidth: "none" }}
            >
              {props.isShow && (
                <div className="w-full">
                  {BaseTabs &&
                    BaseTabs.filter((d) => d.plan)
                      .filter((d) => isPm?.includes(d.Id))
                      .map((item) => {
                        const isDisabled =
                          user && user.userOrganisation.length < 1;
                        const isActive =
                          location.split("/")[1] === item.Path.split("/")[1];

                        return (
                          <div
                            className={`flex gap-2 py-3 px-2 rounded-md items-center ${
                              isActive ? "bg-primary-500" : ""
                            } ${
                              isDisabled
                                ? "cursor-not-allowed opacity-50"
                                : "cursor-pointer"
                            }`}
                            onClick={() => {
                              if (!isDisabled) {
                                navigate(item.Path);
                                props.setOpen(
                                  isMobailView ? !props.isShow : props.isShow
                                );
                              }
                            }}
                          >
                            <div className="md:h-3.5 md:w-3.5 xl:w-5 xl:h-5">
                              <img
                                className="w-full align-middle"
                                src={item.Image}
                                alt="No Image Found"
                              />
                            </div>
                            <div className="md:text-sm lg:text-sm">
                              {item.Name}
                            </div>
                          </div>
                        );
                      })}
                </div>
              )}

              {user && user.userOrganisation.length >= 1 && props.isShow && (
                <div
                  className="w-full  h-full   relative bg-secondary-950"
                  style={{ scrollbarWidth: "none" }}
                >
                  <div className="flex justify-between items-center p-2 w-full sticky -top-[1px] z-50 bg-secondary-950">
                    <div className="md:text-xs xl:text-sm">
                      {t("MY PROJECTS")}
                    </div>
                    {user?.userOrganisation[0]?.role ===
                      UserRoleEnumValue.ADMINISTRATOR && (
                      <div className="md:w-3.5 md:h-3.5 xl:w-5 xl:h-5 ">
                        <img
                          className="w-full align-middle cursor-pointer "
                          src={NewPlus}
                          alt="No Image Found"
                          onClick={handleOpenPopUp}
                        />
                      </div>
                    )}
                  </div>

                  <div className=" md:mt-1.5 w-full" key={`${projectId} ${id}`}>
                    {projectQuery &&
                      convertToHierarchy?.map((item: any) => {
                        if (item && item?.portfolioId) {
                          return (
                            <CollapsibleItem
                              label={item?.portfolioName}
                              type={"portfolio"}
                              item={item}
                              showProjectMenu={showProjectMenu}
                            >
                              {item.programs.map((program: any) => (
                                <CollapsibleItem
                                  label={program.programName}
                                  type="program"
                                  indentLevel={1}
                                  item={item}
                                  showProjectMenu={showProjectMenu}
                                >
                                  {program.projects.map((item: any) => {
                                    if (item && item?.projectId) {
                                      return (
                                        <div>
                                          <div
                                            className={`flex justify-between items-center gap-2 mt-2  p-2 rounded-lg transition duration-150 ${
                                              item?.projectId ===
                                              (projectId ?? id)
                                                ? "bg-[#299d91bd]"
                                                : "bg-[#231c40]"
                                            } ${
                                              item.projectId ==
                                                showProjectMenu && "focus"
                                            } cursor-pointer ${
                                              !item?.isActive
                                                ? "opacity-70 bg-gray-400/30 cursor-not-allowed"
                                                : ""
                                            }`}
                                            onClick={() => {
                                              item?.isActive
                                                ? setShowProjectMenu(
                                                    item.projectId ==
                                                      showProjectMenu
                                                      ? ""
                                                      : item.projectId
                                                  )
                                                : "";
                                              if (
                                                (newProjectRef.current,
                                                containerRef.current)
                                              ) {
                                                containerRef.current.scrollIntoView(
                                                  {
                                                    inline: "end",
                                                    behavior: "smooth",
                                                  }
                                                );
                                              }
                                            }}
                                            autoFocus={
                                              item.projectId == showProjectMenu
                                            }
                                          >
                                            <div className="flex gap-2 items-center justify-between w-full">
                                              <div className="flex gap-2 items-center  w-full">
                                                <div className="w-4 h-4 p-2 relative rounded-full flex justify-center items-center">
                                                  <img
                                                    className={` w-3 h-3 top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 absolute brightness-0 invert ${
                                                      showProjectMenu !==
                                                      item.projectId
                                                        ? "rotate-180"
                                                        : ""
                                                    }`}
                                                    src={NewUpArrow}
                                                    alt="No Image Found"
                                                  />
                                                </div>
                                                <div className="h-5 min-h-5">
                                                  <Package
                                                    size={18}
                                                    className=""
                                                    color="#fff"
                                                  />
                                                </div>
                                                <div className="md:text-sm xl:text-sm truncate w-full">
                                                  {item?.projectName}
                                                </div>
                                              </div>
                                              {/* <div className="w-4 h-4 p-2 relative bg-primary-300 rounded-full flex justify-center items-center">
                                                <img
                                                  className={` w-3 h-3 top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 absolute brightness-0 invert ${
                                                    showProjectMenu === index
                                                      ? "rotate-180"
                                                      : ""
                                                  }`}
                                                  src={NewUpArrow}
                                                  alt="No Image Found"
                                                />
                                              </div> */}
                                            </div>
                                          </div>
                                          <div
                                            className={` transition duration-200${
                                              showProjectMenu === item.projectId
                                                ? "translate-y-0 "
                                                : "-translate-y-full -z-10 opacity-0 absolute"
                                            }`}
                                          >
                                            {ProjectTabs &&
                                              ProjectTabs.filter(
                                                (d) => d.plan
                                              ).map(
                                                (
                                                  projectitem                                                ) => {
                                                  return (
                                                    <div
                                                      ref={(el) =>
                                                        (newProjectRef.current[
                                                          item.projectId
                                                        ] = el)
                                                      }
                                                      className={`px-3 py-2 flex gap-2 mb-1.5 items-center mt-1 cursor-pointer ${
                                                        item.projectId ==
                                                          (id ?? projectId) &&
                                                        location.split(
                                                          "/"
                                                        )[1] ==
                                                          projectitem.Path.split(
                                                            "/"
                                                          )[1] &&
                                                        projectitem.subType ===
                                                          isSubType &&
                                                        "bg-primary-500 rounded-md p-1"
                                                      } `}
                                                      onClick={() => {
                                                        props.setOpen(
                                                          isMobailView
                                                            ? !props.isShow
                                                            : props.isShow
                                                        );
                                                        if (
                                                          projectitem.Name ===
                                                          t("project_workload")
                                                        ) {
                                                          setIsSubType(
                                                            "workload"
                                                          );
                                                          navigate(
                                                            `${projectitem.Path}${item.projectId}?view=GANTT`,
                                                            {
                                                              state: {
                                                                isGanttOpen:
                                                                  true,
                                                              },
                                                            }
                                                          );
                                                        } else {
                                                          navigate(
                                                            `${projectitem.Path}${item.projectId}`
                                                          );
                                                          setIsSubType(
                                                            projectitem.Path.split(
                                                              "/"
                                                            )[1]
                                                          );
                                                        }
                                                      }}
                                                    >
                                                      <div className="md:w-3.5 md:h-3.5 xl:w-5 xl:h-5">
                                                        <img
                                                          className="w-full align-middle"
                                                          src={
                                                            projectitem.Image
                                                          }
                                                          alt="No Image Found"
                                                        />
                                                      </div>
                                                      <div className="md:text-sm xl:text-sm">
                                                        {projectitem.Name}
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              )}
                                          </div>
                                        </div>
                                      );
                                    }
                                  })}
                                </CollapsibleItem>
                              ))}

                              {/* Projects directly under portfolio */}
                              {item?.projects.map((item: any) => {
                                if (item && item?.projectId) {
                                  return (
                                    <div>
                                      <div
                                        className={`flex justify-between items-center gap-2 mt-2  p-2 rounded-lg transition duration-150 ${
                                          item?.projectId === (projectId ?? id)
                                            ? "bg-[#299d91bd]"
                                            : "bg-[#231c40]"
                                        } ${
                                          item.projectId == showProjectMenu &&
                                          "focus"
                                        } cursor-pointer ${
                                          !item?.isActive
                                            ? "opacity-70 bg-gray-400/30 cursor-not-allowed"
                                            : ""
                                        }`}
                                        onClick={() => {
                                          item?.isActive
                                            ? setShowProjectMenu(
                                                item.projectId ==
                                                  showProjectMenu
                                                  ? ""
                                                  : item.projectId
                                              )
                                            : "";
                                          if (
                                            (newProjectRef.current,
                                            containerRef.current)
                                          ) {
                                            containerRef.current.scrollIntoView(
                                              {
                                                inline: "end",
                                                behavior: "smooth",
                                              }
                                            );
                                          }
                                        }}
                                        autoFocus={
                                          item.projectId == showProjectMenu
                                        }
                                      >
                                        <div className="md:text-sm xl:text-sm flex gap-2 items-center w-full">
                                          <div className="flex gap-2 items-center  w-full">
                                            <div className="w-4 h-4 p-2 relative  rounded-full flex justify-center items-center">
                                              <img
                                                className={` w-3 h-3 top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 absolute brightness-0 invert ${
                                                  showProjectMenu !==
                                                  item.projectId
                                                    ? "rotate-180"
                                                    : ""
                                                }`}
                                                src={NewUpArrow}
                                                alt="No Image Found"
                                              />
                                            </div>
                                            <div className="h-5 min-h-5">
                                              <Package size={18} color="#fff" />
                                            </div>
                                            <div className="md:text-sm xl:text-sm truncate w-full">
                                              {item?.projectName}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className={` transition duration-200${
                                          showProjectMenu === item.projectId
                                            ? "translate-y-0 "
                                            : "-translate-y-full -z-10 opacity-0 absolute"
                                        }`}
                                      >
                                        {ProjectTabs &&
                                          ProjectTabs.filter((d) => d.plan).map(
                                            (projectitem) => {
                                              return (
                                                <div
                                                  ref={(el) =>
                                                    (newProjectRef.current[
                                                      item.projectId
                                                    ] = el)
                                                  }
                                                  className={`px-3 py-2 flex gap-2 mb-1.5 items-center mt-1 cursor-pointer ${
                                                    item.projectId ==
                                                      (id ?? projectId) &&
                                                    location.split("/")[1] ==
                                                      projectitem.Path.split(
                                                        "/"
                                                      )[1] &&
                                                    projectitem.subType ===
                                                      isSubType &&
                                                    "bg-primary-500 rounded-md p-1"
                                                  } `}
                                                  onClick={() => {
                                                    props.setOpen(
                                                      isMobailView
                                                        ? !props.isShow
                                                        : props.isShow
                                                    );
                                                    if (
                                                      projectitem.Name ===
                                                      t("project_workload")
                                                    ) {
                                                      setIsSubType("workload");
                                                      navigate(
                                                        `${projectitem.Path}${item.projectId}?view=GANTT`,
                                                        {
                                                          state: {
                                                            isGanttOpen: true,
                                                          },
                                                        }
                                                      );
                                                    } else {
                                                      navigate(
                                                        `${projectitem.Path}${item.projectId}`
                                                      );
                                                      setIsSubType(
                                                        projectitem.Path.split(
                                                          "/"
                                                        )[1]
                                                      );
                                                    }
                                                  }}
                                                >
                                                  <div className="md:w-3.5 md:h-3.5 xl:w-5 xl:h-5">
                                                    <img
                                                      className="w-full align-middle"
                                                      src={projectitem.Image}
                                                      alt="No Image Found"
                                                    />
                                                  </div>
                                                  <div className="md:text-sm xl:text-sm">
                                                    {projectitem.Name}
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                            </CollapsibleItem>
                          );
                        }
                        if (item && item?.programId) {
                          return (
                            <CollapsibleItem
                              label={item?.programName}
                              type={"program"}
                              item={item}
                              showProjectMenu={showProjectMenu}
                            >
                              {/* Projects directly under portfolio */}
                              {item?.projects.map((item: any) => {
                                if (item && item?.projectId) {
                                  return (
                                    <div>
                                      <div
                                        className={`flex justify-between items-center gap-2 mt-2  p-2 rounded-lg transition duration-150 ${
                                          item?.projectId === (projectId ?? id)
                                            ? "bg-[#299d91bd]"
                                            : "bg-[#231c40]"
                                        } ${
                                          item.projectId == showProjectMenu &&
                                          "focus"
                                        } cursor-pointer ${
                                          !item?.isActive
                                            ? "opacity-70 bg-gray-400/30 cursor-not-allowed"
                                            : ""
                                        }`}
                                        onClick={() => {
                                          item?.isActive
                                            ? setShowProjectMenu(
                                                item.projectId ==
                                                  showProjectMenu
                                                  ? ""
                                                  : item.projectId
                                              )
                                            : "";
                                          if (
                                            (newProjectRef.current,
                                            containerRef.current)
                                          ) {
                                            containerRef.current.scrollIntoView(
                                              {
                                                inline: "end",
                                                behavior: "smooth",
                                              }
                                            );
                                          }
                                        }}
                                        autoFocus={
                                          item.projectId == showProjectMenu
                                        }
                                      >
                                        <div className="md:text-sm xl:text-sm flex gap-2 items-center w-full">
                                          <div className="w-4 h-4 relative  rounded-full flex justify-center items-center">
                                            <img
                                              className={` w-3 h-3 top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 absolute brightness-0 invert ${
                                                showProjectMenu !==
                                                item.projectId
                                                  ? "rotate-180"
                                                  : ""
                                              }`}
                                              src={NewUpArrow}
                                              alt="No Image Found"
                                            />
                                          </div>
                                          <div className="flex gap-2 items-center  w-full">
                                            <div className="h-5 min-h-5">
                                              <Package size={18} color="#fff" />
                                            </div>
                                            <div className="md:text-sm xl:text-sm truncate w-full">
                                              {item?.projectName}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className={` transition duration-200${
                                          showProjectMenu === item.projectId
                                            ? "translate-y-0 "
                                            : "-translate-y-full -z-10 opacity-0 absolute"
                                        }`}
                                      >
                                        {ProjectTabs &&
                                          ProjectTabs.filter((d) => d.plan).map(
                                            (projectitem) => {
                                              return (
                                                <div
                                                  ref={(el) =>
                                                    (newProjectRef.current[
                                                      item.projectId
                                                    ] = el)
                                                  }
                                                  className={`px-3 py-2 flex gap-2 mb-1.5 items-center mt-1 cursor-pointer ${
                                                    item.projectId ==
                                                      (id ?? projectId) &&
                                                    location.split("/")[1] ==
                                                      projectitem.Path.split(
                                                        "/"
                                                      )[1] &&
                                                    projectitem.subType ===
                                                      isSubType &&
                                                    "bg-primary-500 rounded-md p-1"
                                                  } `}
                                                  onClick={() => {
                                                    props.setOpen(
                                                      isMobailView
                                                        ? !props.isShow
                                                        : props.isShow
                                                    );
                                                    if (
                                                      projectitem.Name ===
                                                      t("project_workload")
                                                    ) {
                                                      setIsSubType("workload");
                                                      navigate(
                                                        `${projectitem.Path}${item.projectId}?view=GANTT`,
                                                        {
                                                          state: {
                                                            isGanttOpen: true,
                                                          },
                                                        }
                                                      );
                                                    } else {
                                                      navigate(
                                                        `${projectitem.Path}${item.projectId}`
                                                      );
                                                      setIsSubType(
                                                        projectitem.Path.split(
                                                          "/"
                                                        )[1]
                                                      );
                                                    }
                                                  }}
                                                >
                                                  <div className="md:w-3.5 md:h-3.5 xl:w-5 xl:h-5">
                                                    <img
                                                      className="w-full align-middle"
                                                      src={projectitem.Image}
                                                      alt="No Image Found"
                                                    />
                                                  </div>
                                                  <div className="md:text-sm xl:text-sm">
                                                    {projectitem.Name}
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                            </CollapsibleItem>
                          );
                        }
                        if (item && item?.projectId) {
                          return (
                            <div>
                              <div
                                className={`flex justify-between items-center gap-2 mt-2  p-2 rounded-lg transition duration-150 ${
                                  item?.projectId === (projectId ?? id)
                                    ? "bg-[#299d91bd]"
                                    : "bg-[#231c40]"
                                } ${
                                  item.projectId == showProjectMenu && "focus"
                                } cursor-pointer ${
                                  !item?.isActive
                                    ? "opacity-70 bg-gray-400/30 cursor-not-allowed"
                                    : ""
                                }`}
                                onClick={() => {
                                  item?.isActive
                                    ? setShowProjectMenu(
                                        item.projectId == showProjectMenu
                                          ? ""
                                          : item.projectId
                                      )
                                    : "";
                                  if (
                                    (newProjectRef.current,
                                    containerRef.current)
                                  ) {
                                    containerRef.current.scrollIntoView({
                                      inline: "end",
                                      behavior: "smooth",
                                    });
                                  }
                                }}
                                autoFocus={item.projectId == showProjectMenu}
                              >
                                <div className="md:text-sm xl:text-sm flex gap-2 items-center w-full">
                                  <div className="flex gap-2 items-center  w-full">
                                    <img
                                      className={` w-3 h-3  brightness-0 invert ${
                                        showProjectMenu !== item.projectId
                                          ? "rotate-180"
                                          : ""
                                      }`}
                                      src={NewUpArrow}
                                      alt="No Image Found"
                                    />
                                    <div className="h-5 min-h-5">
                                      <Package size={18} color="#fff" />
                                    </div>
                                    <div className="md:text-sm xl:text-sm truncate w-full">
                                      {item?.projectName}
                                    </div>
                                  </div>
                                </div>
                                {/* <div className="w-4 h-4 p-2 relative bg-primary-300 rounded-full flex justify-center items-center">
                                  <img
                                    className={` w-3 h-3 top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 absolute brightness-0 invert ${
                                      showProjectMenu === index
                                        ? "rotate-180"
                                        : ""
                                    }`}
                                    src={NewUpArrow}
                                    alt="No Image Found"
                                  />
                                </div> */}
                              </div>
                              <div
                                className={` transition duration-200${
                                  showProjectMenu === item.projectId
                                    ? "translate-y-0 "
                                    : "-translate-y-full -z-10 opacity-0 absolute"
                                }`}
                              >
                                {ProjectTabs &&
                                  ProjectTabs.filter((d) => d.plan).map(
                                    (projectitem) => {
                                      return (
                                        <div
                                          ref={(el) =>
                                            (newProjectRef.current[
                                              item.projectId
                                            ] = el)
                                          }
                                          className={`px-3 py-2 flex gap-2 mb-1.5 items-center mt-1 cursor-pointer ${
                                            item.projectId ==
                                              (id ?? projectId) &&
                                            location.split("/")[1] ==
                                              projectitem.Path.split("/")[1] &&
                                            projectitem.subType === isSubType &&
                                            "bg-primary-500 rounded-md p-1"
                                          } `}
                                          onClick={() => {
                                            props.setOpen(
                                              isMobailView
                                                ? !props.isShow
                                                : props.isShow
                                            );
                                            if (
                                              projectitem.Name ===
                                              t("project_workload")
                                            ) {
                                              setIsSubType("workload");
                                              navigate(
                                                `${projectitem.Path}${item.projectId}?view=GANTT`,
                                                { state: { isGanttOpen: true } }
                                              );
                                            } else {
                                              navigate(
                                                `${projectitem.Path}${item.projectId}`
                                              );
                                              setIsSubType(
                                                projectitem.Path.split("/")[1]
                                              );
                                            }
                                          }}
                                        >
                                          <div className="md:w-3.5 md:h-3.5 xl:w-5 xl:h-5">
                                            <img
                                              className="w-full align-middle"
                                              src={projectitem.Image}
                                              alt="No Image Found"
                                            />
                                          </div>
                                          <div className="md:text-sm xl:text-sm">
                                            {projectitem.Name}
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                              </div>
                            </div>
                          );
                        }
                      })}
                  </div>
                </div>
              )}
            </div>
            <div>
              {props.isShow && (
                <div className="w-full pb-5 p-5 mt-auto">
                  <button
                    type="button"
                    className="w-full bg-[#231c40] flex items-center gap-3 px-5 py-3 rounded-md md:text-sm xl:text-base"
                    onClick={logout}
                  >
                    <div className="md:w-3.5 md:h-3.5 xl:w-5 xl:h-5">
                      <img
                        className="w-full align-middle"
                        src={NewLogout}
                        alt="No Image Found"
                      />
                    </div>
                    {t("logout")}
                  </button>
                </div>
              )}
              {version && (
                <div className="ml-2">
                  <span className="text-[10px]">{version}</span>
                </div>
              )}
            </div>
          </div>
        </div>
        {isPopUpOpen && (
          <CreateProjectForm handleClosePopUp={handleOpenPopUp} />
        )}
      </div>
    </div>
  );
};

const CollapsibleItem = ({
  label,
  children,
  type,
  showProjectMenu,
  item,
}: {
  label: string;
  showProjectMenu: string;
  children: React.ReactNode;
  type: "portfolio" | "program";
  indentLevel?: number;
  item: any;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpand = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };
  const isExpanding = (item: HierarchyItem): boolean => {
    if (item.type === "project") {
      return item.projectId === showProjectMenu;
    }

    if (item.type === "program") {
      return item.projects.some((p) => p.projectId === showProjectMenu);
    }

    if (item.type === "portfolio") {
      return (
        item.projects.some((p) => p.projectId === showProjectMenu) ||
        item.programs.some((program) =>
          program.projects.some((p) => p.projectId === showProjectMenu)
        )
      );
    }

    return false;
  };

  useEffect(() => {
    setIsExpanded(isExpanding(item));
  }, [item]);

  const typeColors = {
    portfolio: "text-primary-500",
    program: "text-gray-450",
  };
  useEffect(() => {
    if (isExpanded) {
      if (childrenRef) {
        childrenRef.current?.scrollIntoView({ behavior: "auto", block: "end" });
      }
    }
  }, [isExpanded]);
  const childrenRef = useRef<HTMLDivElement>(null);
  return (
    <div className="w-full">
      <Button
        className={cn(
          "w-full  bg-[#231c40] hover:bg-[#231c40] gap-2 mt-2 p-2",
          typeColors[type]
        )}
        onClick={toggleExpand}
      >
        {isExpanded ? (
          <img
            className={` w-3 h-3  brightness-0 invert`}
            src={NewUpArrow}
            alt="No Image Found"
          />
        ) : (
          <img
            className={` w-3 h-3  brightness-0 invert ${"rotate-180"}`}
            src={NewUpArrow}
            alt="No Image Found"
          />
        )}
        <div className="flex gap-2 items-center w-11/12">
          {" "}
          <div className="w-4 min-w-4">
            {type == "portfolio" ? (
              <Briefcase size={18} color="#299d91bd" />
            ) : (
              <Layers size={18} color="#808080" />
            )}{" "}
          </div>
          <div className="truncate">{label}</div>
        </div>
      </Button>

      {
        <div className={`ml-2 ${isExpanded ? "" : "hidden"}`} ref={childrenRef}>
          {children}
        </div>
      }
    </div>
  );
};
